import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AuthHeader.css';

interface AuthHeaderProps {
  showBackButton?: boolean;
  onBack?: () => void;
}

const AuthHeader: React.FC<AuthHeaderProps> = ({ showBackButton = false, onBack }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      // For login flow, go back to email step
      if (window.location.pathname === '/login' && window.location.search.includes('step=pin')) {
        navigate('/login');
      } else {
        navigate(-1);
      }
    }
  };

  return (
    <header className="auth-header">
      {showBackButton && (
        <button className="auth-header-back-btn" onClick={handleBackClick}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M12 19L5 12L12 5" stroke="#070A13" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
      
      <div className={`auth-header-logo ${showBackButton ? 'centered' : 'left'}`}>
        <img 
          src={showBackButton ? "/images/logo-single.png" : "/images/logo-full.png"} 
          alt="aiCourses" 
          className="auth-header-logo-img" 
        />
      </div>
      
      {/* Empty div for spacing when back button is shown */}
      {showBackButton && <div className="auth-header-spacer"></div>}
    </header>
  );
};

export default AuthHeader; 